import React from "react";
import ReactDOM from "react-dom";
import { MainModalContextProvider } from "./contexts/MainModalContext";


const reactElement = document.getElementById('basic-modal-entry');

ReactDOM.render(
  <MainModalContextProvider>
  </MainModalContextProvider>,
  reactElement
);
 